import { render, staticRenderFns } from "./StageDeleteModal.vue?vue&type=template&id=f8a6b330&"
import script from "./StageDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./StageDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports